<div class="mission-upload-container p-4" style="width: 600px">
  <tbs-title [tbsBorderless]="true">Mission Details</tbs-title>
  <span
    >Project:
    {{ missionCreationResult.constructionProject.project.project_name }}</span
  >
  <span>Pilot: {{ user$ | async }} </span>
  <span
    >Flight Date: {{ date }}</span
  >
  <span
    >Mapping Images Uploaded: {{ missionUploadResult.numberOfMapUploads }} of
    {{ missionUploadResult.numberOfMapUploads }}</span
  >
  <span
    >Panorama Images Uploaded:
    {{ missionUploadResult.numberOfPanoramaUploads }} of
    {{ missionUploadResult.numberOfPanoramaUploads }}</span
  >

  <span
    >Other Files Uploaded: {{ missionUploadResult.numberOfOtherUploads }} of
    {{ missionUploadResult.numberOfOtherUploads }}</span
  >
</div>
